import React from "react";
import LegalShell from "./LegalShell";

export default function Cookies() {
  return (
    <LegalShell
      title="Politique de cookies"
      subtitle="Utilisation des cookies et traceurs sur le site DepannRoute."
      lastUpdate="19 février 2026"
      canonical="https://depannroute.com/cookies"
    >
      <h2>1. Qu'est-ce qu'un cookie ?</h2>
      <p>
        Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette,
        mobile) lors de la consultation d'un site. Il permet au site de reconnaître votre navigateur
        et de mémoriser des informations utiles à votre expérience utilisateur.
      </p>

      <h2>2. Cookies utilisés par DepannRoute</h2>
      <table>
        <thead>
          <tr>
            <th>Nom</th>
            <th>Type</th>
            <th>Finalité</th>
            <th>Durée</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>access_token</code></td>
            <td>Essentiel</td>
            <td>Authentification JWT (httpOnly, Secure, SameSite)</td>
            <td>24 heures</td>
          </tr>
          <tr>
            <td><code>refresh_token</code></td>
            <td>Essentiel</td>
            <td>Renouvellement de session</td>
            <td>7 jours</td>
          </tr>
          <tr>
            <td><code>session_token</code></td>
            <td>Essentiel</td>
            <td>Session Google OAuth (httpOnly, Secure)</td>
            <td>7 jours</td>
          </tr>
          <tr>
            <td><code>_ga</code>, <code>_ga_*</code></td>
            <td>Analytics (optionnel)</td>
            <td>Mesure d'audience anonymisée</td>
            <td>13 mois max.</td>
          </tr>
        </tbody>
      </table>

      <h2>3. Vos choix</h2>
      <p>
        Les <strong>cookies essentiels</strong> sont nécessaires au fonctionnement du site
        (authentification, sécurité) et ne requièrent pas de consentement préalable.
      </p>
      <p>
        Les <strong>cookies de mesure d'audience</strong> ne sont déposés qu'avec votre consentement
        explicite. Vous pouvez à tout moment :
      </p>
      <ul>
        <li>Configurer votre navigateur pour bloquer les cookies ou être averti avant leur dépôt.</li>
        <li>Retirer votre consentement via le lien « Gérer mes cookies » en pied de page.</li>
      </ul>

      <h2>4. Configurer votre navigateur</h2>
      <ul>
        <li><strong>Chrome :</strong> Paramètres &gt; Confidentialité et sécurité &gt; Cookies.</li>
        <li><strong>Firefox :</strong> Options &gt; Vie privée et sécurité.</li>
        <li><strong>Safari :</strong> Préférences &gt; Confidentialité.</li>
        <li><strong>Edge :</strong> Paramètres &gt; Cookies et autorisations du site.</li>
      </ul>

      <h2>5. Pour en savoir plus</h2>
      <p>
        La CNIL propose un guide complet sur les cookies :{" "}
        <a href="https://www.cnil.fr/fr/cookies-et-autres-traceurs" target="_blank" rel="noopener noreferrer">
          cnil.fr/cookies-et-autres-traceurs
        </a>.
      </p>
    </LegalShell>
  );
}
